export const tableHeader = [
  'Session Name',
  'Topic',
  'Subject',
  'Course Name',
  'Branch',
  'Batch',
  'Institute',
  'Status',
  'Assigned Teacher',
  'Date',
  'Start Time',
  'End Time',
  'Action'
]
